import React, { Component } from "react";
import { withGate } from "../../components/Gate";
import connected from "./connected";
import Timezone from "./Timezone";

// Make sure user was loaded
const UserRequiredTimezone = withGate(Timezone, "_id");

export default connected(UserRequiredTimezone);



// WEBPACK FOOTER //
// ./src/routes/Timezone/index.js